import React, { useState, useEffect, useCallback, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';
import { useAuth } from '../context/AuthContext';
import { toast } from 'sonner';
import CallButton from '../components/CallButton';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Badge } from '@/components/ui/badge';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger,
} from '@/components/ui/dialog';
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from '@/components/ui/select';
import {
  Sheet, SheetContent, SheetHeader, SheetTitle,
} from '@/components/ui/sheet';
import {
  Tooltip, TooltipContent, TooltipProvider, TooltipTrigger,
} from '@/components/ui/tooltip';
import {
  Upload, Search, Phone, MessageCircle, StickyNote,
  Plus, Trash2, Send, ChevronLeft, ChevronRight, ChevronDown, FileSpreadsheet,
  Filter, ClipboardList, CheckCircle, XCircle, Clock, FileText,
  RotateCcw, Calendar, Bell, Archive, AlertTriangle, Pencil, ArrowRightLeft,
  PhoneCall, Loader2, ShieldCheck, ShieldAlert, ShieldX, Car,
  CreditCard, MoreVertical, ExternalLink, Mail, Edit2, Landmark
} from 'lucide-react';
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import WhatsAppConversation from '../components/WhatsAppConversation';

const MESI = ['', 'Gennaio', 'Febbraio', 'Marzo', 'Aprile', 'Maggio', 'Giugno', 'Luglio', 'Agosto', 'Settembre', 'Ottobre', 'Novembre', 'Dicembre'];

const ESITI = {
  da_contattare: { label: 'Da Contattare', color: 'bg-white border-slate-200 text-slate-700', dot: 'bg-slate-300' },
  avvisato:      { label: 'Avvisato',      color: 'bg-sky-50 border-sky-300 text-sky-800', dot: 'bg-sky-400' },
  in_attesa:     { label: 'In Attesa',     color: 'bg-amber-50 border-amber-300 text-amber-800', dot: 'bg-amber-400' },
  preventivo:    { label: 'Preventivo',    color: 'bg-blue-50 border-blue-300 text-blue-800', dot: 'bg-blue-400' },
  non_rinnova:   { label: 'Non Rinnova',   color: 'bg-red-50 border-red-300 text-red-800', dot: 'bg-red-400' },
  rinnovato:     { label: 'Rinnovato',     color: 'bg-emerald-50 border-emerald-300 text-emerald-800', dot: 'bg-emerald-400' },
};

const extractDay = (dataStr) => {
  if (!dataStr) return 99;
  const match = dataStr.match(/^(\d{1,2})\//);
  return match ? parseInt(match[1]) : 99;
};

const Scadenze = () => {
  const { isAdmin } = useAuth();
  const navigate = useNavigate();
  const [scadenze, setScadenze] = useState([]);
  const [rinnovati, setRinnovati] = useState([]);
  const [cestino, setCestino] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mese, setMese] = useState(new Date().getMonth() + 1);
  const [anno, setAnno] = useState(new Date().getFullYear());
  const [searchQ, setSearchQ] = useState('');
  const [compagnieList, setCompagnieList] = useState([]);
  const [filterCompagnia, setFilterCompagnia] = useState('');
  const [filterEsito, setFilterEsito] = useState('');
  const [filterGiorno, setFilterGiorno] = useState('');
  const [tab, setTab] = useState('attivi');
  const [importOpen, setImportOpen] = useState(false);
  const [addOpen, setAddOpen] = useState(false);
  const [selectedScadenza, setSelectedScadenza] = useState(null);
  const [sheetOpen, setSheetOpen] = useState(false);
  const [importFile, setImportFile] = useState(null);
  const [importing, setImporting] = useState(false);
  const [noteText, setNoteText] = useState('');
  const [taskOpen, setTaskOpen] = useState(false);
  const [sintesiTarget, setSintesiTarget] = useState(null);
  const [sintesiData, setSintesiData] = useState(null);
  const [sintesiLoading, setSintesiLoading] = useState(false);
  const [freeTarga, setFreeTarga] = useState('');

  const handleSintesi = async (s) => {
    setSintesiTarget(s);
    setSintesiData(null);
    setSintesiLoading(true);
    try {
      const r = await api.get(`/ai-assistant/sintesi-lookup?targa=${encodeURIComponent(s.targa)}`, { timeout: 90000 });
      setSintesiData(r.data);
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore consultazione Sintesi');
      setSintesiTarget(null);
    } finally { setSintesiLoading(false); }
  };

  const handleFreeSintesi = () => {
    const t = freeTarga.trim().replace(/\s/g, '').toUpperCase();
    if (t.length < 5) { toast.error('Inserisci una targa valida'); return; }
    handleSintesi({ targa: t });
  };

  const RINNOVO_BADGES = {
    rinnovata_noi: { label: '✓ Rinnovata', cls: 'bg-emerald-100 text-emerald-700 border-emerald-200' },
    rinnovata_altrove: { label: 'Rinnovata altrove', cls: 'bg-sky-100 text-sky-700 border-sky-200' },
    da_verificare: { label: 'Da verificare', cls: 'bg-amber-100 text-amber-700 border-amber-200' },
  };
  const rinnovoBadge = (s, suffix = '') => {
    const rc = s.rinnovo_check;
    const info = rc && RINNOVO_BADGES[rc.stato];
    if (!info) return null;
    return (
      <Tooltip>
        <TooltipTrigger asChild>
          <span className={`text-[9px] px-1.5 py-0.5 rounded-full border font-semibold cursor-help whitespace-nowrap ${info.cls}`} data-testid={`rinnovo-badge-${s.id}${suffix}`}>
            {info.label}
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-[280px]">
          <p className="text-xs">{rc.dettaglio}</p>
        </TooltipContent>
      </Tooltip>
    );
  };
  // Etichetta autore invio WA: operatore (nome) oppure invio automatico dello scheduler
  const waSenderLabel = (by, mode) => {
    if (mode === 'automatico' || by === 'Automatico') return 'Automatico · Assistente Virtuale';
    return by || '';
  };
  // Formatta data + ora italiane: "30/09/2026 alle 14:32"
  const fmtWaSent = (iso) => {
    if (!iso) return '';
    const d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    return `${d.toLocaleDateString('it-IT')} alle ${d.toLocaleTimeString('it-IT', { hour: '2-digit', minute: '2-digit' })}`;
  };
  const [taskTarget, setTaskTarget] = useState(null);
  const [users, setUsers] = useState([]);
  const [editingNote, setEditingNote] = useState(null);
  const [editNoteText, setEditNoteText] = useState('');
  const [inlineNoteId, setInlineNoteId] = useState(null);
  const [inlineNoteVal, setInlineNoteVal] = useState('');
  const [spostaOpen, setSpostaOpen] = useState(false);
  const [spostaTarget, setSpostaTarget] = useState(null);
  const [spostaDest, setSpostaDest] = useState({ giorno: 1, mese: 1, anno: new Date().getFullYear() });
  // Selezione multipla + invio massivo WA
  const [selectedIds, setSelectedIds] = useState(new Set());
  const [bulkWaDelay, setBulkWaDelay] = useState(15);
  const [bulkWaJob, setBulkWaJob] = useState({ running: false, total: 0, sent: 0, failed: 0, current: '' });
  const [bulkConfirmOpen, setBulkConfirmOpen] = useState(false);
  // Edit inline cellulare
  const [editPhoneId, setEditPhoneId] = useState(null);
  const [editPhoneVal, setEditPhoneVal] = useState('');
  const [savingPhone, setSavingPhone] = useState(false);
  // Raggruppamento clienti con più polizze
  const [expandedClients, setExpandedClients] = useState(new Set());
  const [clientPolizze, setClientPolizze] = useState({}); // {nominativo: [...polizze]}

  const toggleExpand = async (nominativo) => {
    const isExpanded = expandedClients.has(nominativo);
    if (isExpanded) {
      setExpandedClients(prev => { const n = new Set(prev); n.delete(nominativo); return n; });
      return;
    }
    // Carica le polizze del cliente (se non già in cache)
    if (!clientPolizze[nominativo]) {
      try {
        const r = await api.get(`/scadenze?search=${encodeURIComponent(nominativo)}`);
        const all = (r.data || []).filter(x => x.nominativo === nominativo && !x.deleted);
        setClientPolizze(prev => ({ ...prev, [nominativo]: all }));
      } catch (e) { console.error('expand client:', e); }
    }
    setExpandedClients(prev => new Set(prev).add(nominativo));
  };
  const [newScadenza, setNewScadenza] = useState({
    nominativo: '', cellulare: '', email: '', compagnia: '',
    targa: '', tipo_veicolo: '', garanzie: '', frequenza_pagamento: '',
    premio: '', note: ''
  });
  const [rcaOpen, setRcaOpen] = useState(false);
  const [rcaTarga, setRcaTarga] = useState('');
  const [rcaLoading, setRcaLoading] = useState(null);
  const [rcaResult, setRcaResult] = useState(null);
  const [multiCount, setMultiCount] = useState({});
  const [paymentLoading, setPaymentLoading] = useState(null);
  const [paymentOpen, setPaymentOpen] = useState(false);
  const [paymentTarget, setPaymentTarget] = useState(null);
  const [paymentUrl, setPaymentUrl] = useState('');
  const [payments, setPayments] = useState([]);

  const fetchScadenze = useCallback(async () => {
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.set('mese', mese);
      params.set('anno', anno);
      if (filterCompagnia) params.set('compagnia', filterCompagnia);
      if (searchQ) params.set('search', searchQ);
      if (tab === 'cestino') {
        const res = await api.get(`/scadenze/cestino?${params}`);
        setCestino(res.data);
      } else if (tab === 'attivi') {
        if (filterEsito) params.set('esito', filterEsito);
        else params.set('esito', 'attivi');
        const res = await api.get(`/scadenze?${params}`);
        setScadenze(res.data);
      } else {
        params.set('esito', 'rinnovato');
        const res = await api.get(`/scadenze?${params}`);
        setRinnovati(res.data);
      }
    } catch (e) { console.error('fetchScadenze:', e); toast.error('Errore caricamento scadenze'); }
    finally { setLoading(false); }
  }, [mese, anno, filterCompagnia, filterEsito, searchQ, tab]);

  const fetchCompagnie = useCallback(async () => {
    try { const res = await api.get('/scadenze/compagnie'); setCompagnieList(res.data); } catch (e) { console.error('fetchCompagnie:', e); }
  }, []);
  const fetchUsers = useCallback(async () => {
    try { const res = await api.get('/users'); setUsers(res.data || []); } catch (e) { console.error('fetchUsers:', e); }
  }, []);

  useEffect(() => { fetchCompagnie(); fetchUsers(); }, [fetchCompagnie, fetchUsers]);

  // Stato job bulk WA: aggiornato solo on-demand (no polling per evitare set-state-in-effect)

  // Selezione multipla
  const toggleSelect = (id) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      if (next.has(id)) next.delete(id); else next.add(id);
      return next;
    });
  };
  const toggleSelectAllVisible = (idsToToggle) => {
    setSelectedIds(prev => {
      const next = new Set(prev);
      const allSelected = idsToToggle.every(id => next.has(id));
      if (allSelected) idsToToggle.forEach(id => next.delete(id));
      else idsToToggle.forEach(id => next.add(id));
      return next;
    });
  };
  const clearSelection = () => setSelectedIds(new Set());

  const startBulkWA = async () => {
    if (selectedIds.size === 0) { toast.error('Seleziona almeno una scadenza'); return; }
    try {
      const r = await api.post('/scadenze/send-wa-bulk', {
        scadenza_ids: Array.from(selectedIds),
        delay_minutes: bulkWaDelay,
      });
      toast.success(r.data.info || 'Invio massivo avviato');
      setBulkConfirmOpen(false);
      clearSelection();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore avvio invio');
    }
  };

  const cancelBulkWA = async () => {
    try {
      await api.post('/scadenze/send-wa-bulk/cancel');
      toast.success('Invio massivo interrotto');
    } catch { toast.error('Errore'); }
  };

  // Verifica RCA su scadenze selezionate
  const [bulkRcaRunning, setBulkRcaRunning] = useState(false);
  const [bulkRcaProgress, setBulkRcaProgress] = useState({ done: 0, total: 0 });
  const startBulkRca = async () => {
    const ids = Array.from(selectedIds).filter(id => {
      const s = scadenze.find(x => x.id === id);
      return s && s.targa;
    });
    if (ids.length === 0) { toast.error('Nessuna scadenza selezionata con targa'); return; }
    if (!window.confirm(`Verificare la RCA di ${ids.length} targhe?\n\nL'operazione puo' richiedere ~2 secondi per targa.\nTempo stimato: ${Math.ceil(ids.length * 2)} secondi.`)) return;
    setBulkRcaRunning(true);
    setBulkRcaProgress({ done: 0, total: ids.length });
    let verificate = 0, daVerificare = 0, datiIncompleti = 0;
    // Esegui in chunk da 10 per non sovraccaricare l'API esterna
    const chunkSize = 10;
    try {
      for (let i = 0; i < ids.length; i += chunkSize) {
        const chunk = ids.slice(i, i + chunkSize);
        const r = await api.post('/scadenze/verifica-targhe-selezionate', { scadenza_ids: chunk });
        const d = r.data || {};
        verificate += d.verificate || 0;
        daVerificare += d.da_verificare || 0;
        datiIncompleti += d.dati_incompleti || 0;
        setBulkRcaProgress({ done: Math.min(i + chunkSize, ids.length), total: ids.length });
        // Refresh parziale per vedere lo stato aggiornarsi
        if (i + chunkSize < ids.length) await fetchScadenze();
      }
      toast.success(`✅ Verifica completata: ${verificate} verificate, ${daVerificare} da verificare, ${datiIncompleti} con dati incompleti (su ${ids.length} totali)`);
      clearSelection();
      await fetchScadenze();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore verifica RCA');
    } finally {
      setBulkRcaRunning(false);
      setBulkRcaProgress({ done: 0, total: 0 });
    }
  };

  // Salvataggio inline numero di telefono
  const startEditPhone = (s) => {
    setEditPhoneId(s.id);
    setEditPhoneVal(s.cellulare || '');
  };
  const cancelEditPhone = () => {
    setEditPhoneId(null);
    setEditPhoneVal('');
  };
  const savePhone = async (s) => {
    const cleaned = editPhoneVal.trim();
    if (cleaned === (s.cellulare || '')) { cancelEditPhone(); return; }
    setSavingPhone(true);
    try {
      await api.patch(`/scadenze/${s.id}`, { cellulare: cleaned });
      // Aggiorna localmente: nuovo numero + reset eventuale stato "failed" (così l'utente può riprovare)
      setScadenze(prev => prev.map(x => x.id === s.id ? { ...x, cellulare: cleaned, wa_reminder_failed: false, wa_reminder_failed_reason: '' } : x));
      toast.success('Numero aggiornato');
      cancelEditPhone();
    } catch (e) {
      toast.error(e.response?.data?.detail || 'Errore aggiornamento numero');
    } finally {
      setSavingPhone(false);
    }
  };
  // Carica multi-count e unread WA insieme al refresh principale (no useEffect dedicati)
  const fetchScadenzeAndCounts = useCallback(async () => {
    await fetchScadenze();
    try {
      const r = await api.get(`/scadenze/multi-count?mese=${mese}&anno=${anno}`);
      setMultiCount(r.data);
    } catch (e) { console.error('multi-count:', e); }
  }, [fetchScadenze, mese, anno]);

  const fetchPayments = useCallback(async () => {
    try { const r = await api.get('/scadenze/payments/list'); setPayments(r.data); } catch (e) { console.error('payments:', e); }
  }, []);

  useEffect(() => { fetchScadenzeAndCounts(); }, [fetchScadenzeAndCounts]);
  useEffect(() => {
    if (tab === 'pagamenti') fetchPayments();
  }, [tab, fetchPayments]);

  const handleImport = async (e) => {
    e.preventDefault();
    if (!importFile) return;
    setImporting(true);
    try {
      const fd = new FormData();
      fd.append('file', importFile);
      fd.append('mese', mese);
      fd.append('anno', anno);
      const res = await api.post('/scadenze/import', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      toast.success(`Importate ${res.data.imported} scadenze`);
      setImportOpen(false);
      setImportFile(null);
      fetchScadenze();
      fetchCompagnie();
    } catch (err) {
      const detail = err.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Errore import. Verifica il formato del file.');
    }
    finally { setImporting(false); }
  };

  const handleAddManual = async (e) => {
    e.preventDefault();
    try {
      await api.post('/scadenze', { ...newScadenza, mese, anno });
      toast.success('Scadenza aggiunta');
      setAddOpen(false);
      setNewScadenza({ nominativo: '', cellulare: '', email: '', compagnia: '', targa: '', tipo_veicolo: '', garanzie: '', frequenza_pagamento: '', premio: '', note: '' });
      fetchScadenze();
    } catch { toast.error('Errore aggiunta'); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Spostare questa scadenza nel cestino?')) return;
    try {
      await api.delete(`/scadenze/${id}`);
      setScadenze(prev => prev.filter(s => s.id !== id));
      setRinnovati(prev => prev.filter(s => s.id !== id));
      if (selectedScadenza?.id === id) { setSheetOpen(false); setSelectedScadenza(null); }
      toast.success('Spostata nel cestino');
    } catch { toast.error('Errore'); }
  };

  const handleRestore = async (id) => {
    try {
      await api.put(`/scadenze/${id}/restore`);
      setCestino(prev => prev.filter(s => s.id !== id));
      toast.success('Scadenza ripristinata!');
    } catch { toast.error('Errore ripristino'); }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm(`Spostare TUTTE le scadenze di ${MESI[mese]} ${anno} nel cestino?`)) return;
    try {
      const res = await api.delete(`/scadenze?mese=${mese}&anno=${anno}`);
      toast.success(res.data.message);
      setScadenze([]);
      setRinnovati([]);
    } catch { toast.error('Errore'); }
  };

  const handleEsito = async (id, esito) => {
    try {
      // Trova esito attuale per toggle
      const current = [...scadenze, ...rinnovati].find(s => s.id === id);
      const newEsito = current?.esito === esito ? 'da_contattare' : esito;
      const res = await api.put(`/scadenze/${id}/esito`, { esito: newEsito });
      const updatedData = res.data;
      if (newEsito === 'rinnovato') {
        setScadenze(prev => prev.filter(s => s.id !== id));
        toast.success('Spostato nei Rinnovati');
      } else if (current?.esito === 'rinnovato' && newEsito !== 'rinnovato') {
        setRinnovati(prev => prev.filter(s => s.id !== id));
        toast.success('Riportato nelle attive');
      } else {
        setScadenze(prev => prev.map(s => s.id === id ? { ...s, esito: newEsito, esito_by: updatedData.esito_by } : s));
        toast.success(newEsito === 'da_contattare' ? 'Stato rimosso' : `Esito: ${ESITI[newEsito]?.label}`);
      }
      if (selectedScadenza?.id === id) {
        if (newEsito === 'rinnovato') { setSheetOpen(false); setSelectedScadenza(null); }
        else setSelectedScadenza(prev => ({ ...prev, esito: newEsito, esito_by: updatedData.esito_by }));
      }
    } catch { toast.error('Errore'); }
  };

  const handleAddNote = async () => {
    if (!noteText.trim() || !selectedScadenza) return;
    try {
      const res = await api.post(`/scadenze/${selectedScadenza.id}/note`, { testo: noteText });
      setSelectedScadenza(prev => ({ ...prev, note_list: [...(prev.note_list || []), res.data] }));
      setNoteText('');
    } catch { toast.error('Errore'); }
  };

  const handleEditNote = async (noteId) => {
    if (!editNoteText.trim() || !selectedScadenza) return;
    try {
      await api.put(`/scadenze/${selectedScadenza.id}/note/${noteId}`, { testo: editNoteText });
      setSelectedScadenza(prev => ({ ...prev, note_list: (prev.note_list || []).map(n => n.id === noteId ? { ...n, testo: editNoteText } : n) }));
      setEditingNote(null); setEditNoteText('');
    } catch { toast.error('Errore'); }
  };

  const handleDeleteNote = async (noteId) => {
    try {
      await api.delete(`/scadenze/${selectedScadenza.id}/note/${noteId}`);
      setSelectedScadenza(prev => ({ ...prev, note_list: (prev.note_list || []).filter(n => n.id !== noteId) }));
    } catch { toast.error('Errore'); }
  };

  const handleCreateTask = async (e) => {
    e.preventDefault();
    const form = e.target;
    try {
      await api.post('/tasks', { titolo: form.titolo.value, descrizione: form.descrizione.value, priorita: 'media', assignee_id: form.assignee.value || null });
      toast.success('Task creato!');
      setTaskOpen(false); setTaskTarget(null);
    } catch (err) { toast.error(err.response?.data?.detail || 'Errore'); }
  };

  const [sendingWaId, setSendingWaId] = useState(null);
  const openWhatsApp = async (s) => {
    const num = (s.cellulare || '').replace(/[^0-9+]/g, '');
    if (!num || num.length < 8) {
      toast.error('Nessun numero valido per il cliente');
      // Marca come "fallito" lato UI così il badge diventa rosso
      setScadenze(prev => prev.map(x => x.id === s.id ? { ...x, wa_reminder_failed: true, wa_reminder_failed_reason: 'Numero mancante o non valido' } : x));
      return;
    }
    if (s.wa_reminder_sent) {
      if (!window.confirm('Promemoria WhatsApp gia\' inviato per questa scadenza. Vuoi inviarlo di nuovo?')) return;
    }
    setSendingWaId(s.id);
    try {
      const res = await api.post(`/scadenze/${s.id}/send-wa-now`);
      if (res.data?.success) {
        toast.success(`Promemoria WhatsApp inviato a ${s.nominativo}`);
        setScadenze(prev => prev.map(x => x.id === s.id ? { ...x, wa_reminder_sent: true, wa_reminder_failed: false, wa_reminder_sent_at: new Date().toISOString() } : x));
      } else {
        toast.error('Risposta inattesa dal server');
        setScadenze(prev => prev.map(x => x.id === s.id ? { ...x, wa_reminder_failed: true, wa_reminder_failed_reason: 'Risposta inattesa' } : x));
      }
    } catch (err) {
      const errMsg = err.response?.data?.detail || 'Errore invio WhatsApp';
      toast.error(errMsg);
      setScadenze(prev => prev.map(x => x.id === s.id ? { ...x, wa_reminder_failed: true, wa_reminder_failed_reason: errMsg } : x));
    } finally {
      setSendingWaId(null);
    }
  };

  const [callingId, setCallingId] = useState(null);
  const handleVoipCall = async (s) => {
    if (!s.cellulare) { toast.error('Nessun numero'); return; }
    setCallingId(s.id);
    try {
      const res = await api.post('/centralino/call', { number: s.cellulare, description: s.nominativo || '' });
      toast.success(res.data.message || 'Chiamata avviata!');
    } catch (err) { toast.error(err.response?.data?.detail || 'Errore avvio chiamata'); }
    finally { setCallingId(null); }
  };

  const openPreventivo = (s) => {
    navigate(`/preventivi?${new URLSearchParams({ nome: s.nominativo || '', targa: s.targa || '', compagnia: s.compagnia || '', cellulare: s.cellulare || '' })}`);
  };

  const handleInlineNoteSave = async (id, val) => {
    try {
      await api.put(`/scadenze/${id}/nota`, { testo: val });
      const updateFn = prev => prev.map(s => s.id === id ? { ...s, note: val } : s);
      if (tab === 'attivi') setScadenze(updateFn);
      else setRinnovati(updateFn);
    } catch { toast.error('Errore salvataggio nota'); }
    setInlineNoteId(null);
  };

  const handleSposta = async () => {
    if (!spostaTarget) return;
    try {
      await api.put(`/scadenze/${spostaTarget.id}/sposta`, {
        giorno_destinazione: spostaDest.giorno,
        mese_destinazione: spostaDest.mese,
        anno_destinazione: spostaDest.anno
      });
      setScadenze(prev => prev.filter(s => s.id !== spostaTarget.id));
      setRinnovati(prev => prev.filter(s => s.id !== spostaTarget.id));
      if (selectedScadenza?.id === spostaTarget.id) { setSheetOpen(false); setSelectedScadenza(null); }
      toast.success(`Scadenza spostata al ${spostaDest.giorno}/${spostaDest.mese}/${spostaDest.anno}`);
      setSpostaOpen(false); setSpostaTarget(null);
    } catch { toast.error('Errore spostamento'); }
  };

  const handleCreatePaymentLink = async (scadenza) => {
    setPaymentLoading(scadenza.id);
    try {
      const origin = window.location.origin;
      const r = await api.post(`/scadenze/${scadenza.id}/payment-link`, { origin_url: origin });
      setPaymentUrl(r.data.url);
      setPaymentTarget(scadenza);
      setPaymentOpen(true);
      toast.success(`Link pagamento creato: ${r.data.importo.toFixed(2)} EUR`);
      // update scadenza locally
      const updateFn = prev => prev.map(s => s.id === scadenza.id ? { ...s, payment_url: r.data.url, payment_stato: 'in_attesa', payment_importo: r.data.importo } : s);
      setScadenze(updateFn);
      if (selectedScadenza?.id === scadenza.id) setSelectedScadenza(prev => ({ ...prev, payment_url: r.data.url, payment_stato: 'in_attesa', payment_importo: r.data.importo }));
    } catch (e) { toast.error(e.response?.data?.detail || 'Errore creazione link'); }
    finally { setPaymentLoading(null); }
  };

  const handleSendPaymentLink = async (scadenza, metodo) => {
    try {
      await api.post(`/scadenze/${scadenza.id}/send-payment-link?metodo=${metodo}`);
      toast.success(`Link pagamento inviato via ${metodo === 'whatsapp' ? 'WhatsApp' : 'Email'}!`);
    } catch (e) { toast.error(e.response?.data?.detail || `Errore invio ${metodo}`); }
  };

  const getMultiExtra = (nominativo) => {
    if (!nominativo) return 0;
    const key = nominativo.trim().toLowerCase();
    const count = multiCount[key] || 0;
    return count > 1 ? count - 1 : 0;
  };

  const prevMonth = () => { if (mese === 1) { setMese(12); setAnno(a => a - 1); } else setMese(m => m - 1); };
  const nextMonth = () => { if (mese === 12) { setMese(1); setAnno(a => a + 1); } else setMese(m => m + 1); };

  const handleCheckRca = async (targa, scadenzaId = null) => {
    setRcaLoading(scadenzaId || 'manual');
    try {
      let res;
      if (scadenzaId) {
        res = await api.post(`/scadenze/${scadenzaId}/check-rca`);
      } else {
        res = await api.post('/scadenze/check-rca', { targa });
      }
      setRcaResult(res.data);
      if (scadenzaId) {
        // Aggiorna la scadenza nella lista con i dati RCA
        const updateFn = prev => prev.map(s => s.id === scadenzaId ? {
          ...s,
          rca_assicurato: res.data.assicurato,
          rca_compagnia: res.data.compagnia_rca,
          rca_scadenza: res.data.scadenza_annuale || res.data.scadenza_polizza,
          rca_scadenza_rata: res.data.scadenza_rata || '',
          rca_frequenza: res.data.frequenza || '',
          rca_sospesa: res.data.assicurazione_sospesa,
          rca_furto: res.data.furto_segnalato,
          rca_verificato_at: res.data.verificato_at,
        } : s);
        setScadenze(updateFn);
        setRinnovati(updateFn);
        if (selectedScadenza?.id === scadenzaId) {
          setSelectedScadenza(prev => ({
            ...prev,
            rca_assicurato: res.data.assicurato,
            rca_compagnia: res.data.compagnia_rca,
            rca_scadenza: res.data.scadenza_annuale || res.data.scadenza_polizza,
            rca_scadenza_rata: res.data.scadenza_rata || '',
            rca_frequenza: res.data.frequenza || '',
            rca_sospesa: res.data.assicurazione_sospesa,
            rca_furto: res.data.furto_segnalato,
            rca_verificato_at: res.data.verificato_at,
          }));
        }
      }
      if (!scadenzaId) setRcaOpen(true);
      toast.success(`Verifica completata: ${res.data.assicurato ? 'Assicurato' : 'NON Assicurato'}`);
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Errore verifica RCA');
      setRcaResult(null);
    } finally {
      setRcaLoading(null);
    }
  };

  const handleManualRcaCheck = () => {
    if (!rcaTarga.trim()) { toast.error('Inserisci una targa'); return; }
    handleCheckRca(rcaTarga.trim());
  };

  const fmtPremi = (v) => {
    if (!v) return '-';
    const s = String(v);
    if (s.includes('(ann.')) {
      const parts = s.match(/([\d.]+)\s*\(ann\.\s*([\d.]+)\)/);
      if (parts) return `${Number(parts[1]).toFixed(2)} € (ann. ${Number(parts[2]).toFixed(2)} €)`;
    }
    const n = parseFloat(s);
    return isNaN(n) ? s : `${n.toFixed(2)} €`;
  };

  // Apply day filter + group by date
  const activeList = tab === 'attivi' ? scadenze : tab === 'rinnovati' ? rinnovati : cestino;
  const filtered = filterGiorno
    ? activeList.filter(s => extractDay(s.data_scadenza) === parseInt(filterGiorno))
    : activeList;

  const grouped = {};
  filtered.forEach(s => {
    const dateKey = s.data_scadenza || 'Senza data';
    if (!grouped[dateKey]) grouped[dateKey] = [];
    grouped[dateKey].push(s);
  });
  const dateKeys = Object.keys(grouped).sort((a, b) => extractDay(a) - extractDay(b));

  // Get unique days for filter
  const uniqueDays = [...new Set(activeList.map(s => extractDay(s.data_scadenza)).filter(d => d < 32))].sort((a, b) => a - b);

  const esitoStats = {};
  scadenze.forEach(s => { const e = s.esito || 'da_contattare'; esitoStats[e] = (esitoStats[e] || 0) + 1; });

  const tipoScBadge = (tipo, freq) => {
    if (!tipo && !freq) return null;
    const label = [freq, tipo].filter(Boolean).join(' - ');
    return (
      <span className="text-[10px] px-1.5 py-0.5 rounded font-medium bg-blue-50 text-blue-700">
        {label}
      </span>
    );
  };

  const checkDateMatch = (dataStr) => {
    if (!dataStr || dataStr === 'Senza data') return null;
    const match = dataStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (!match) return null;
    const dateMese = parseInt(match[2]);
    const dateAnno = parseInt(match[3]);
    if (dateMese !== mese || dateAnno !== anno) {
      return `Data ${dataStr} non corrisponde a ${MESI[mese]} ${anno}`;
    }
    return null;
  };

  return (
    <TooltipProvider delayDuration={200}>
    <div className="p-4 md:p-6 max-w-7xl mx-auto" data-testid="scadenze-page">
      {/* Header */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3 mb-5">
        <div>
          <h1 className="text-2xl font-bold text-slate-900">Scadenze Polizze</h1>
          <p className="text-slate-500 text-sm">{filtered.length} scadenze - {MESI[mese]} {anno}</p>
        </div>
        <div className="flex gap-2 flex-wrap">
          <Button className="bg-indigo-600 hover:bg-indigo-700" onClick={() => { setRcaTarga(''); setRcaResult(null); setRcaOpen(true); }} data-testid="check-rca-btn">
            <ShieldCheck size={16} className="mr-2" /> Verifica RCA
          </Button>
          <Dialog open={importOpen} onOpenChange={setImportOpen}>
            <DialogTrigger asChild>
              <Button className="bg-emerald-600 hover:bg-emerald-700" data-testid="import-btn"><Upload size={16} className="mr-2" /> Importa XLS</Button>
            </DialogTrigger>
            <DialogContent>
              <DialogHeader><DialogTitle>Importa Scadenze da File</DialogTitle></DialogHeader>
              <form onSubmit={handleImport} className="space-y-4">
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Mese</Label>
                    <Select value={String(mese)} onValueChange={v => setMese(Number(v))}><SelectTrigger><SelectValue /></SelectTrigger>
                      <SelectContent>{MESI.slice(1).map((m, i) => <SelectItem key={i+1} value={String(i+1)}>{m}</SelectItem>)}</SelectContent>
                    </Select>
                  </div>
                  <div><Label>Anno</Label><Input type="number" value={anno} onChange={e => setAnno(Number(e.target.value))} /></div>
                </div>
                <div><Label>File (.xlsx o .csv)</Label><Input type="file" accept=".xlsx,.xls,.csv" onChange={e => setImportFile(e.target.files[0])} required /></div>
                <Button type="submit" className="w-full" disabled={importing}>{importing ? 'Importando...' : 'Importa'}</Button>
              </form>
            </DialogContent>
          </Dialog>
          <Dialog open={addOpen} onOpenChange={setAddOpen}>
            <DialogTrigger asChild><Button variant="outline" data-testid="add-manual-btn"><Plus size={16} className="mr-2" /> Aggiungi</Button></DialogTrigger>
            <DialogContent className="max-w-lg">
              <DialogHeader><DialogTitle>Nuova Scadenza</DialogTitle></DialogHeader>
              <form onSubmit={handleAddManual} className="space-y-3">
                <div className="grid grid-cols-2 gap-3">
                  <div><Label>Nominativo *</Label><Input required value={newScadenza.nominativo} onChange={e => setNewScadenza(p => ({...p, nominativo: e.target.value}))} /></div>
                  <div><Label>Cellulare</Label><Input value={newScadenza.cellulare} onChange={e => setNewScadenza(p => ({...p, cellulare: e.target.value}))} /></div>
                  <div><Label>Compagnia</Label><Input value={newScadenza.compagnia} onChange={e => setNewScadenza(p => ({...p, compagnia: e.target.value}))} /></div>
                  <div><Label>Targa</Label><Input value={newScadenza.targa} onChange={e => setNewScadenza(p => ({...p, targa: e.target.value}))} /></div>
                </div>
                <Button type="submit" className="w-full">Aggiungi</Button>
              </form>
            </DialogContent>
          </Dialog>
          {isAdmin && scadenze.length > 0 && (
            <Button variant="outline" className="text-red-500 border-red-200 hover:bg-red-50" onClick={handleDeleteAll} data-testid="delete-all-btn"><Trash2 size={16} className="mr-2" /> Svuota Mese</Button>
          )}
        </div>
      </div>

      {/* Tabs */}
      <div className="flex gap-1 mb-4 bg-slate-100 p-1 rounded-lg w-fit flex-wrap">
        <button onClick={() => setTab('attivi')} className={`px-4 py-2 rounded-md text-sm font-medium transition-all ${tab === 'attivi' ? 'bg-white shadow-sm text-slate-900' : 'text-slate-500'}`} data-testid="tab-attivi">Scadenze Attive</button>
        <button onClick={() => setTab('rinnovati')} className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-1.5 ${tab === 'rinnovati' ? 'bg-white shadow-sm text-emerald-700' : 'text-slate-500'}`} data-testid="tab-rinnovati"><CheckCircle size={14} /> Rinnovati</button>
        <button onClick={() => setTab('pagamenti')} className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-1.5 ${tab === 'pagamenti' ? 'bg-white shadow-sm text-blue-700' : 'text-slate-500'}`} data-testid="tab-pagamenti"><CreditCard size={14} /> Pagamenti</button>
        <button onClick={() => setTab('cestino')} className={`px-4 py-2 rounded-md text-sm font-medium transition-all flex items-center gap-1.5 ${tab === 'cestino' ? 'bg-white shadow-sm text-red-600' : 'text-slate-500'}`} data-testid="tab-cestino"><Archive size={14} /> Cestino</button>
      </div>

      {/* Bulk WA Status Bar (visibile quando job attivo) */}
      {bulkWaJob.running && (
        <div className="mb-3 p-3 rounded-xl bg-amber-50 border border-amber-200 flex items-center gap-3 flex-wrap" data-testid="bulk-wa-status">
          <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-amber-600" />
          <div className="flex-1 min-w-[200px]">
            <p className="text-sm font-semibold text-amber-900">Invio WhatsApp massivo in corso</p>
            <p className="text-xs text-amber-700">
              {bulkWaJob.sent + bulkWaJob.failed}/{bulkWaJob.total} processati · {bulkWaJob.sent} inviati · {bulkWaJob.failed} falliti
              {bulkWaJob.current && ` · ora: ${bulkWaJob.current}`}
            </p>
            <div className="mt-1 h-1.5 bg-amber-100 rounded-full overflow-hidden">
              <div className="h-full bg-amber-500 transition-all" style={{ width: `${bulkWaJob.total > 0 ? ((bulkWaJob.sent + bulkWaJob.failed) / bulkWaJob.total) * 100 : 0}%` }} />
            </div>
          </div>
          <Button size="sm" variant="outline" onClick={cancelBulkWA} className="text-xs">Ferma</Button>
        </div>
      )}

      {/* Bulk WA Action Bar (visibile quando ci sono scadenze selezionate) */}
      {selectedIds.size > 0 && !bulkWaJob.running && (
        <div className="mb-3 p-3 rounded-xl bg-emerald-50 border-2 border-emerald-200 flex items-center gap-3 flex-wrap" data-testid="bulk-action-bar">
          <span className="text-sm font-bold text-emerald-900">{selectedIds.size} scadenze selezionate</span>
          <div className="flex items-center gap-1 text-xs text-slate-600">
            Delay:
            <Input type="number" min={1} max={60} value={bulkWaDelay} onChange={e => setBulkWaDelay(parseInt(e.target.value) || 15)} className="w-16 h-7 text-xs" data-testid="bulk-delay" />
            min
          </div>
          <Button size="sm" onClick={() => setBulkConfirmOpen(true)} className="bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="bulk-send-wa-btn">
            <MessageCircle size={14} className="mr-1.5" /> Invia WhatsApp alle selezionate
          </Button>
          <Button size="sm" onClick={startBulkRca} disabled={bulkRcaRunning} className="bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="bulk-rca-btn">
            {bulkRcaRunning ? (
              <><Loader2 size={14} className="animate-spin mr-1.5" /> Verifica {bulkRcaProgress.done}/{bulkRcaProgress.total}</>
            ) : (
              <><ShieldCheck size={14} className="mr-1.5" /> Verifica RCA selezionate</>
            )}
          </Button>
          <Button size="sm" variant="ghost" onClick={clearSelection} className="text-slate-500">Annulla selezione</Button>
        </div>
      )}

      {/* Modal conferma invio bulk */}
      <Dialog open={bulkConfirmOpen} onOpenChange={setBulkConfirmOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader>
            <DialogTitle>Conferma invio WhatsApp massivo</DialogTitle>
          </DialogHeader>
          <div className="space-y-2 text-sm text-slate-700">
            <p>Stai per inviare <b>{selectedIds.size}</b> messaggi WhatsApp di promemoria scadenza.</p>
            <p>I messaggi verranno inviati uno ogni <b>{bulkWaDelay} minuti</b> (anti-ban WA).</p>
            <p className="text-xs text-slate-500">Tempo stimato: ~{Math.floor(((selectedIds.size - 1) * bulkWaDelay) / 60)}h {((selectedIds.size - 1) * bulkWaDelay) % 60}min</p>
            <p className="text-xs text-amber-700 bg-amber-50 p-2 rounded">⚠️ Le scadenze senza cellulare valido verranno saltate automaticamente.</p>
          </div>
          <div className="flex gap-2 mt-4">
            <Button variant="outline" onClick={() => setBulkConfirmOpen(false)} className="flex-1">Annulla</Button>
            <Button onClick={startBulkWA} className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white" data-testid="confirm-bulk-send">Conferma invio</Button>
          </div>
        </DialogContent>
      </Dialog>

      {/* Esito filters */}
      {tab === 'attivi' && scadenze.length > 0 && (
        <div className="flex gap-2 mb-4 flex-wrap">
          {Object.entries(ESITI).filter(([k]) => k !== 'rinnovato').map(([key, val]) => (
            <button key={key} onClick={() => setFilterEsito(filterEsito === key ? '' : key)}
              className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${filterEsito === key ? val.color + ' ring-2 ring-offset-1 ring-slate-300' : 'bg-white border-slate-200 text-slate-500 hover:border-slate-300'}`}
              data-testid={`filter-esito-${key}`}>
              <span className={`inline-block w-2 h-2 rounded-full mr-1.5 ${val.dot}`} />
              {val.label} {esitoStats[key] ? `(${esitoStats[key]})` : ''}
            </button>
          ))}
        </div>
      )}

      {/* Month nav + filters */}
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3 mb-5 flex-wrap">
        <div className="flex items-center gap-2 bg-white rounded-lg border px-2 py-1">
          <Button variant="ghost" size="sm" onClick={prevMonth} data-testid="prev-month"><ChevronLeft size={18} /></Button>
          <span className="font-semibold text-sm min-w-[140px] text-center">{MESI[mese]} {anno}</span>
          <Button variant="ghost" size="sm" onClick={nextMonth} data-testid="next-month"><ChevronRight size={18} /></Button>
        </div>

        {/* Day filter */}
        <Select value={filterGiorno || '_all'} onValueChange={v => setFilterGiorno(v === '_all' ? '' : v)}>
          <SelectTrigger className="w-[130px] h-9">
            <Calendar size={14} className="mr-2" /><SelectValue placeholder="Giorno" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="_all">Tutti i giorni</SelectItem>
            {uniqueDays.map(d => <SelectItem key={d} value={String(d)}>Giorno {d}</SelectItem>)}
          </SelectContent>
        </Select>

        <div className="relative flex-1 min-w-[180px] max-w-xs">
          <Search size={14} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-slate-400" />
          <Input value={searchQ} onChange={e => setSearchQ(e.target.value)} placeholder="Cerca nome, targa..." className="pl-8 h-9 text-sm" data-testid="search-scadenze" />
        </div>
        <Select value={filterCompagnia || '_all'} onValueChange={v => setFilterCompagnia(v === '_all' ? '' : v)}>
          <SelectTrigger className="w-[180px] h-9"><Filter size={14} className="mr-2" /><SelectValue placeholder="Tutte le compagnie" /></SelectTrigger>
          <SelectContent><SelectItem value="_all">Tutte le compagnie</SelectItem>{compagnieList.map(c => <SelectItem key={c} value={c}>{c}</SelectItem>)}</SelectContent>
        </Select>

        {/* Ricerca libera su Sintesi */}
        <div className="flex items-center gap-1">
          <div className="relative">
            <Landmark size={13} className="absolute left-2.5 top-1/2 -translate-y-1/2 text-indigo-400" />
            <Input
              value={freeTarga}
              onChange={e => setFreeTarga(e.target.value.toUpperCase())}
              onKeyDown={e => { if (e.key === 'Enter') handleFreeSintesi(); }}
              placeholder="Targa su Sintesi..."
              className="pl-8 h-9 text-sm w-[150px] font-mono uppercase"
              maxLength={8}
              data-testid="sintesi-free-input"
            />
          </div>
          <Button size="sm" onClick={handleFreeSintesi} className="h-9 bg-indigo-600 hover:bg-indigo-700 text-white" data-testid="sintesi-free-btn">
            <Search size={13} className="mr-1" /> Sintesi
          </Button>
        </div>
      </div>

      {/* Content */}
      {tab === 'pagamenti' ? null : loading ? (
        <div className="flex items-center justify-center h-40"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-emerald-600" /></div>
      ) : filtered.length === 0 ? (
        <div className="text-center py-16 bg-white rounded-xl border">
          <FileSpreadsheet size={48} className="mx-auto mb-4 text-slate-300" />
          <p className="text-slate-500 text-lg">{tab === 'rinnovati' ? 'Nessuna polizza rinnovata' : `Nessuna scadenza${filterGiorno ? ` per il giorno ${filterGiorno}` : ''}`}</p>
        </div>
      ) : (
        <div className="space-y-4">
          {dateKeys.map(dateKey => (
            <div key={dateKey} className="bg-white rounded-xl border overflow-hidden">
              <div className="bg-slate-50 px-4 py-2 border-b flex items-center gap-2">
                <span className="font-bold text-sm text-indigo-700 min-w-[90px]">{dateKey}</span>
                {checkDateMatch(dateKey) && (
                  <Tooltip>
                    <TooltipTrigger asChild>
                      <span className="text-amber-500 cursor-help"><AlertTriangle size={14} /></span>
                    </TooltipTrigger>
                    <TooltipContent className="bg-amber-50 text-amber-800 border-amber-200">
                      <p className="text-xs">{checkDateMatch(dateKey)}</p>
                    </TooltipContent>
                  </Tooltip>
                )}
                <Badge variant="secondary" className="text-xs">{grouped[dateKey].length} polizze</Badge>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full text-sm">
                  <thead>
                    <tr className="border-b bg-slate-50/50">
                      <th className="text-left px-2 py-2 w-8">
                        <input
                          type="checkbox"
                          checked={grouped[dateKey].length > 0 && grouped[dateKey].every(s => selectedIds.has(s.id))}
                          onChange={() => toggleSelectAllVisible(grouped[dateKey].map(s => s.id))}
                          className="rounded border-slate-300"
                          title="Seleziona tutte di questo giorno"
                          data-testid={`select-all-${dateKey}`}
                        />
                      </th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600 w-8"></th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600">Nominativo</th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600 hidden md:table-cell">Compagnia</th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600 hidden sm:table-cell">Targa</th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600 hidden lg:table-cell">Tipo</th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600 hidden lg:table-cell">Premio</th>
                      <th className="text-left px-3 py-2 font-medium text-slate-600">Note</th>
                      <th className="text-right px-3 py-2 font-medium text-slate-600">Azioni</th>
                    </tr>
                  </thead>
                  <tbody>
                    {grouped[dateKey].map(s => {
                      const esitoInfo = ESITI[s.esito] || ESITI.da_contattare;
                      const hasNoteList = (s.note_list || []).length > 0;
                      const multiExtra = getMultiExtra(s.nominativo);
                      const isExpanded = expandedClients.has(s.nominativo);
                      const altrePolizze = (clientPolizze[s.nominativo] || []).filter(p => p.id !== s.id);
                      return (
                        <React.Fragment key={s.id}>
                        <tr className={`border-b last:border-0 transition-colors ${selectedIds.has(s.id) ? 'bg-emerald-50' : esitoInfo.color}`} data-testid={`scadenza-row-${s.id}`}>
                          <td className="px-2 py-2">
                            <input
                              type="checkbox"
                              checked={selectedIds.has(s.id)}
                              onChange={() => toggleSelect(s.id)}
                              className="rounded border-slate-300"
                              data-testid={`select-${s.id}`}
                            />
                          </td>
                          <td className="px-3 py-2"><span className={`inline-block w-3 h-3 rounded-full ${esitoInfo.dot}`} title={esitoInfo.label} /></td>
                          <td className="px-3 py-2">
                            <div className="flex items-center gap-1.5">
                              {multiExtra > 0 && (
                                <button
                                  onClick={(e) => { e.stopPropagation(); toggleExpand(s.nominativo); }}
                                  className="p-0.5 rounded hover:bg-violet-100 text-violet-600 transition-transform"
                                  title={`${multiExtra} altre polizze di questo cliente`}
                                  data-testid={`expand-${s.id}`}
                                >
                                  {isExpanded ? <ChevronDown size={14} /> : <ChevronRight size={14} />}
                                </button>
                              )}
                              <button onClick={() => { setSelectedScadenza(s); setSheetOpen(true); }} className="font-medium text-slate-900 hover:text-blue-600 text-left" data-testid={`open-detail-${s.id}`}>{s.nominativo}</button>
                              {multiExtra > 0 && (
                                <span className="text-[9px] px-1.5 py-0.5 rounded-full bg-violet-100 text-violet-700 font-bold" title={`${multiExtra} altre scadenze`}>
                                  +{multiExtra}
                                </span>
                              )}
                              {s.wa_unread_count > 0 && (
                                <span className="inline-flex items-center justify-center min-w-[16px] h-[16px] px-1 rounded-full bg-red-500 text-white text-[9px] font-bold animate-pulse" title={`${s.wa_unread_count} messaggi WhatsApp non letti`} data-testid={`wa-unread-${s.id}`}>
                                  {s.wa_unread_count > 9 ? '9+' : s.wa_unread_count}
                                </span>
                              )}
                            </div>
                            {editPhoneId === s.id ? (
                              <div className="flex items-center gap-1 mt-0.5" onClick={(e) => e.stopPropagation()}>
                                <input
                                  type="tel"
                                  value={editPhoneVal}
                                  onChange={(e) => setEditPhoneVal(e.target.value)}
                                  onKeyDown={(e) => {
                                    if (e.key === 'Enter') { e.preventDefault(); savePhone(s); }
                                    else if (e.key === 'Escape') cancelEditPhone();
                                  }}
                                  autoFocus
                                  placeholder="+39 333 1234567"
                                  className="text-xs px-1.5 py-0.5 border border-emerald-300 rounded w-36 focus:outline-none focus:ring-1 focus:ring-emerald-400"
                                  data-testid={`edit-phone-input-${s.id}`}
                                />
                                <button onClick={() => savePhone(s)} disabled={savingPhone} className="p-0.5 rounded hover:bg-emerald-100 text-emerald-600" title="Salva" data-testid={`save-phone-${s.id}`}>
                                  {savingPhone ? <Loader2 size={12} className="animate-spin" /> : <CheckCircle size={12} />}
                                </button>
                                <button onClick={cancelEditPhone} className="p-0.5 rounded hover:bg-red-100 text-red-500" title="Annulla">
                                  <XCircle size={12} />
                                </button>
                              </div>
                            ) : (
                              <button
                                onClick={(e) => { e.stopPropagation(); startEditPhone(s); }}
                                className="text-xs text-slate-500 hover:text-emerald-600 hover:bg-emerald-50 px-1 -ml-1 rounded inline-flex items-center gap-1 group"
                                title="Clicca per modificare il numero"
                                data-testid={`phone-cell-${s.id}`}
                              >
                                {s.cellulare ? (
                                  <>
                                    <Phone size={10} className="text-slate-300 group-hover:text-emerald-500" />
                                    <span>{s.cellulare}</span>
                                    <Edit2 size={9} className="opacity-0 group-hover:opacity-60" />
                                  </>
                                ) : (
                                  <span className="text-red-500 italic flex items-center gap-1">
                                    <Phone size={10} /> Manca numero - clicca per aggiungere
                                  </span>
                                )}
                              </button>
                            )}
                            <div className="sm:hidden text-xs text-slate-400 mt-0.5 flex items-center gap-1.5 flex-wrap">
                              {s.compagnia && <span>{s.compagnia}</span>}
                              {s.targa && <span className="font-mono bg-slate-100 px-1 rounded">{s.targa}</span>}
                              {rinnovoBadge(s, '-m')}
                            </div>
                          </td>
                          <td className="px-3 py-2 text-xs text-slate-600 hidden md:table-cell">{s.compagnia || '-'}</td>
                          <td className="px-3 py-2 hidden sm:table-cell">
                            {s.targa ? (
                              <div className="flex items-center gap-1">
                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <span className="font-mono text-xs bg-slate-100 px-2 py-0.5 rounded cursor-help">{s.targa}</span>
                                  </TooltipTrigger>
                                  {(s.tipo_mezzo || s.tipo_veicolo) && (
                                    <TooltipContent>
                                      <p className="text-xs font-semibold">{s.tipo_mezzo || s.tipo_veicolo}</p>
                                    </TooltipContent>
                                  )}
                                </Tooltip>
                                {s.rca_verificato_at && (
                                  <Tooltip>
                                    <TooltipTrigger asChild>
                                      <span>{s.rca_assicurato ? <ShieldCheck size={13} className="text-emerald-500" /> : <ShieldX size={13} className="text-red-500" />}</span>
                                    </TooltipTrigger>
                                    <TooltipContent>
                                      <p className="text-xs">{s.rca_assicurato ? `Assicurato - ${s.rca_compagnia || ''}` : 'NON Assicurato'}{s.rca_scadenza ? ` (scad. contratto ${s.rca_scadenza})` : ''}{s.rca_frequenza && s.rca_frequenza !== 'Annuale' ? ` [${s.rca_frequenza}]` : ''}</p>
                                    </TooltipContent>
                                  </Tooltip>
                                )}
                                {/* Bottone Verifica RCA rapido - sostituisce la voce nel dropdown */}
                                <Tooltip>
                                  <TooltipTrigger asChild>
                                    <button
                                      onClick={() => handleCheckRca(s.targa, s.id)}
                                      disabled={rcaLoading === s.id}
                                      className="p-1 rounded-md bg-violet-100 hover:bg-violet-200 text-violet-700 disabled:opacity-50 transition-colors"
                                      data-testid={`rca-quick-${s.id}`}
                                      title="Verifica RCA"
                                    >
                                      {rcaLoading === s.id ? <Loader2 size={11} className="animate-spin" /> : <ShieldCheck size={11} />}
                                    </button>
                                  </TooltipTrigger>
                                  <TooltipContent>
                                    <p className="text-xs">Verifica copertura RCA</p>
                                  </TooltipContent>
                                </Tooltip>
                                {rinnovoBadge(s)}
                              </div>
                            ) : '-'}
                          </td>
                          <td className="px-3 py-2 hidden lg:table-cell">{tipoScBadge(s.tipo_scadenza, s.frequenza_pagamento)}</td>
                          <td className="px-3 py-2 text-xs font-medium hidden lg:table-cell">{fmtPremi(s.premio)}</td>
                          <td className="px-3 py-2 min-w-[120px] max-w-[180px]" data-testid={`note-cell-${s.id}`}>
                            {inlineNoteId === s.id ? (
                              <textarea
                                autoFocus
                                className="w-full text-xs border rounded px-2 py-1 bg-white resize-none focus:outline-none focus:ring-1 focus:ring-blue-400"
                                rows={2}
                                value={inlineNoteVal}
                                onChange={e => setInlineNoteVal(e.target.value)}
                                onBlur={() => handleInlineNoteSave(s.id, inlineNoteVal)}
                                onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleInlineNoteSave(s.id, inlineNoteVal); } if (e.key === 'Escape') setInlineNoteId(null); }}
                                data-testid={`note-edit-${s.id}`}
                              />
                            ) : (
                              <div className="flex items-center gap-1 cursor-pointer group" onClick={() => { setInlineNoteId(s.id); setInlineNoteVal(s.note || ''); }}
                                title="Clicca per modificare la nota">
                                <span className="text-xs text-slate-500 truncate block flex-1 group-hover:text-blue-600 transition-colors">
                                  {s.note || <span className="text-slate-300 italic">+ nota</span>}
                                </span>
                                {hasNoteList && (
                                  <button onClick={e => { e.stopPropagation(); setSelectedScadenza(s); setSheetOpen(true); }}
                                    className="shrink-0 p-0.5 rounded text-amber-500 hover:text-amber-700 hover:bg-amber-50" title={`${s.note_list.length} nota/e`}
                                    data-testid={`note-icon-${s.id}`}>
                                    <StickyNote size={13} />
                                  </button>
                                )}
                              </div>
                            )}
                          </td>
                          <td className="px-3 py-2 text-right">
                            <div className="flex items-center justify-end gap-1.5">
                              {tab === 'cestino' ? (
                                <button onClick={() => handleRestore(s.id)} className="p-1.5 rounded-md bg-emerald-100 text-emerald-700 hover:bg-emerald-200 flex items-center gap-1 text-xs font-medium" title="Ripristina" data-testid={`restore-btn-${s.id}`}><RotateCcw size={14} /> Ripristina</button>
                              ) : tab === 'rinnovati' ? (
                                <button onClick={() => handleEsito(s.id, 'rinnovato')} className="p-1.5 rounded-md hover:bg-slate-200 text-slate-500" title="Riporta nelle attive"><RotateCcw size={14} /></button>
                              ) : (
                                <>
                                  {/* ── Gruppo stato WhatsApp ── */}
                                  <div className="flex items-center gap-1.5">
                                  {/* Bottone Invia WhatsApp (visibile diretto, no più dentro al menu) */}
                                  {!s.wa_reminder_sent && !s.wa_reminder_failed && (
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <button
                                          onClick={() => openWhatsApp(s)}
                                          disabled={sendingWaId === s.id}
                                          className="p-1.5 rounded-md bg-green-100 hover:bg-green-200 text-green-700 disabled:opacity-50 flex items-center gap-1"
                                          data-testid={`wa-quick-btn-${s.id}`}
                                          title="Invia promemoria WhatsApp"
                                        >
                                          {sendingWaId === s.id ? <Loader2 size={13} className="animate-spin" /> : <MessageCircle size={13} />}
                                        </button>
                                      </TooltipTrigger>
                                      <TooltipContent><p className="text-xs">Invia promemoria WhatsApp al cliente</p></TooltipContent>
                                    </Tooltip>
                                  )}
                                  {/* Badge stato invio: VERDE = inviato, ROSSO = fallito */}
                                  {s.wa_reminder_sent && !s.wa_reminder_failed && (
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <button
                                          onClick={() => openWhatsApp(s)}
                                          disabled={sendingWaId === s.id}
                                          className="inline-flex items-center gap-0.5 px-1.5 py-1 rounded-md bg-green-100 text-green-700 text-[10px] font-medium hover:bg-green-200"
                                          data-testid={`wa-sent-${s.id}`}
                                          title="WA inviato - clicca per rinviare"
                                        >
                                          <CheckCircle size={11} /> WA
                                        </button>
                                      </TooltipTrigger>
                                      <TooltipContent>
                                        <p className="text-xs">
                                          Promemoria WA inviato
                                          {(() => { const lbl = waSenderLabel(s.wa_reminder_sent_by, s.wa_reminder_mode); return lbl ? ` da ${lbl}` : ''; })()}
                                          {s.wa_reminder_sent_at ? ` il ${fmtWaSent(s.wa_reminder_sent_at)}` : ''}
                                        </p>
                                        {s.wa_reminder15_sent && (
                                          <p className="text-[10px] text-slate-400 mt-0.5">
                                            Anticipo 15gg{(() => { const lbl = waSenderLabel(s.wa_reminder15_sent_by, s.wa_reminder15_mode); return lbl ? ` (${lbl})` : ''; })()}{s.wa_reminder15_sent_at ? ` · ${fmtWaSent(s.wa_reminder15_sent_at)}` : ''}
                                          </p>
                                        )}
                                        <p className="text-[10px] text-slate-400 mt-0.5">Clicca per re-inviare</p>
                                      </TooltipContent>
                                    </Tooltip>
                                  )}
                                  {s.wa_reminder_failed && (
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <button
                                          onClick={() => openWhatsApp(s)}
                                          disabled={sendingWaId === s.id}
                                          className="inline-flex items-center gap-0.5 px-1.5 py-1 rounded-md bg-red-100 text-red-700 text-[10px] font-medium hover:bg-red-200 animate-pulse"
                                          data-testid={`wa-failed-${s.id}`}
                                          title="WA non inviato - clicca per riprovare"
                                        >
                                          {sendingWaId === s.id ? <Loader2 size={11} className="animate-spin" /> : <XCircle size={11} />} WA
                                        </button>
                                      </TooltipTrigger>
                                      <TooltipContent>
                                        <p className="text-xs font-semibold text-red-600">Invio WhatsApp fallito</p>
                                        <p className="text-[10px] text-slate-500 mt-0.5">{s.wa_reminder_failed_reason || 'Motivo sconosciuto'}</p>
                                        <p className="text-[10px] text-slate-400 mt-0.5">Clicca per riprovare</p>
                                      </TooltipContent>
                                    </Tooltip>
                                  )}
                                  </div>
                                  {/* separatore: stato WhatsApp | azioni interne */}
                                  <div className="hidden sm:block w-px h-5 bg-slate-200 mx-1.5" />
                                  {/* ── Gruppo azioni interne ── */}
                                  <div className="hidden sm:flex items-center gap-1.5">
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <button onClick={() => handleEsito(s.id, 'avvisato')} className={`p-1.5 rounded-md transition-colors ${s.esito === 'avvisato' ? 'bg-sky-200 text-sky-800 ring-1 ring-sky-400' : 'hover:bg-sky-100 text-sky-500'}`} data-testid={`avvisato-btn-${s.id}`}><Bell size={14} /></button>
                                      </TooltipTrigger>
                                      <TooltipContent><p className="text-xs">{s.esito === 'avvisato' ? 'Cliente avvisato — clicca per annullare' : 'Segna come avvisato'}</p></TooltipContent>
                                    </Tooltip>
                                    <Tooltip>
                                      <TooltipTrigger asChild>
                                        <button onClick={() => handleEsito(s.id, 'in_attesa')} className={`p-1.5 rounded-md transition-colors ${s.esito === 'in_attesa' ? 'bg-amber-200 text-amber-800 ring-1 ring-amber-400' : 'hover:bg-amber-100 text-amber-500'}`}><Clock size={14} /></button>
                                      </TooltipTrigger>
                                      <TooltipContent><p className="text-xs">{s.esito === 'in_attesa' ? 'In attesa — clicca per annullare' : 'Segna come in attesa'}</p></TooltipContent>
                                    </Tooltip>
                                    {/* Pillola esito Rinnovato/Non Rinnova unificata */}
                                    <DropdownMenu>
                                      <DropdownMenuTrigger asChild>
                                        <button
                                          className={`inline-flex items-center gap-1 px-2 py-1 rounded-full text-[10px] font-semibold transition-colors ${
                                            s.esito === 'rinnovato' ? 'bg-emerald-100 text-emerald-700 hover:bg-emerald-200'
                                            : s.esito === 'non_rinnova' ? 'bg-red-100 text-red-700 hover:bg-red-200'
                                            : 'border border-dashed border-slate-300 text-slate-400 hover:border-slate-400 hover:text-slate-600'
                                          }`}
                                          title={s.esito === 'rinnovato' ? 'Polizza rinnovata — clicca per cambiare esito' : s.esito === 'non_rinnova' ? 'Cliente non rinnova — clicca per cambiare esito' : 'Imposta esito rinnovo'}
                                          data-testid={`esito-pill-${s.id}`}
                                        >
                                          {s.esito === 'rinnovato' ? (<><CheckCircle size={11} /> Rinnovato</>)
                                            : s.esito === 'non_rinnova' ? (<><XCircle size={11} /> Non rinnova</>)
                                            : (<>Esito</>)}
                                          <ChevronDown size={10} className="opacity-60" />
                                        </button>
                                      </DropdownMenuTrigger>
                                      <DropdownMenuContent align="end" className="w-40">
                                        <DropdownMenuItem onClick={() => handleEsito(s.id, 'rinnovato')} data-testid={`esito-rinnovato-${s.id}`}>
                                          <CheckCircle size={14} className="mr-2 text-emerald-500" /> Rinnovato
                                        </DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => handleEsito(s.id, 'non_rinnova')} data-testid={`esito-non-rinnova-${s.id}`}>
                                          <XCircle size={14} className="mr-2 text-red-500" /> Non rinnova
                                        </DropdownMenuItem>
                                      </DropdownMenuContent>
                                    </DropdownMenu>
                                  </div>
                                  {s.esito_by && s.esito !== 'da_contattare' && <span className="text-[9px] text-slate-400 max-w-[50px] truncate hidden lg:inline" title={s.esito_by}>{s.esito_by}</span>}
                                  {/* Dropdown actions menu */}
                                  <DropdownMenu>
                                    <DropdownMenuTrigger asChild>
                                      <button className="p-1.5 rounded-md hover:bg-slate-200 text-slate-500" data-testid={`actions-menu-${s.id}`}><MoreVertical size={15} /></button>
                                    </DropdownMenuTrigger>
                                    <DropdownMenuContent align="end" className="w-48">
                                      {s.cellulare && <DropdownMenuItem onClick={(e) => e.preventDefault()} data-testid={`call-btn-${s.id}`}><CallButton number={s.cellulare} description={s.nominativo || ''} variant="button" className="flex items-center gap-2 w-full text-left text-sm"><PhoneCall size={14} className="mr-2 text-blue-600" /> Chiama</CallButton></DropdownMenuItem>}
                                      <DropdownMenuItem onClick={() => openPreventivo(s)}><FileText size={14} className="mr-2 text-purple-600" /> Preventivo</DropdownMenuItem>
                                      <DropdownMenuItem onClick={() => { setTaskTarget(s); setTaskOpen(true); }}><ClipboardList size={14} className="mr-2 text-amber-600" /> Crea Task</DropdownMenuItem>
                                      {s.targa && <DropdownMenuItem onClick={() => handleSintesi(s)} data-testid={`sintesi-btn-${s.id}`}><Landmark size={14} className="mr-2 text-indigo-600" /> Consulta Sintesi</DropdownMenuItem>}
                                      <DropdownMenuSeparator />
                                      {s.premio && (
                                        <DropdownMenuItem onClick={() => handleCreatePaymentLink(s)} disabled={paymentLoading === s.id} data-testid={`payment-btn-${s.id}`}>
                                          <CreditCard size={14} className="mr-2 text-blue-600" /> {paymentLoading === s.id ? 'Creando...' : 'Link Pagamento'}
                                        </DropdownMenuItem>
                                      )}
                                      {s.payment_url && s.cellulare && <DropdownMenuItem onClick={() => handleSendPaymentLink(s, 'whatsapp')}><MessageCircle size={14} className="mr-2 text-green-600" /> Invia Link WA</DropdownMenuItem>}
                                      {s.payment_url && s.email && <DropdownMenuItem onClick={() => handleSendPaymentLink(s, 'email')}><Mail size={14} className="mr-2 text-orange-600" /> Invia Link Email</DropdownMenuItem>}
                                      <DropdownMenuSeparator />
                                      <DropdownMenuItem onClick={() => { const parts = (s.data_scadenza || '').split('/'); const g = parseInt(parts[0]) || 1; setSpostaTarget(s); setSpostaDest({ giorno: g, mese: mese === 12 ? 1 : mese + 1, anno: mese === 12 ? anno + 1 : anno }); setSpostaOpen(true); }} data-testid={`sposta-btn-${s.id}`}><ArrowRightLeft size={14} className="mr-2 text-indigo-500" /> Sposta</DropdownMenuItem>
                                      <DropdownMenuItem onClick={() => handleDelete(s.id)} className="text-red-600" data-testid={`delete-btn-${s.id}`}><Trash2 size={14} className="mr-2" /> Cestina</DropdownMenuItem>
                                      {/* Mobile esito buttons */}
                                      <div className="sm:hidden">
                                        <DropdownMenuSeparator />
                                        <DropdownMenuItem onClick={() => handleEsito(s.id, 'avvisato')}><Bell size={14} className="mr-2 text-sky-500" /> Avvisato</DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => handleEsito(s.id, 'in_attesa')}><Clock size={14} className="mr-2 text-amber-500" /> In Attesa</DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => handleEsito(s.id, 'rinnovato')}><CheckCircle size={14} className="mr-2 text-emerald-500" /> Rinnovato</DropdownMenuItem>
                                        <DropdownMenuItem onClick={() => handleEsito(s.id, 'non_rinnova')}><XCircle size={14} className="mr-2 text-red-500" /> Non Rinnova</DropdownMenuItem>
                                      </div>
                                    </DropdownMenuContent>
                                  </DropdownMenu>
                                </>
                              )}
                            </div>
                          </td>
                        </tr>
                        {isExpanded && altrePolizze.length > 0 && altrePolizze.map(p => (
                          <tr key={`exp-${p.id}`} className="bg-violet-50/40 border-b border-violet-100 text-xs">
                            <td className="px-2 py-1.5">
                              <input
                                type="checkbox"
                                checked={selectedIds.has(p.id)}
                                onChange={() => toggleSelect(p.id)}
                                className="rounded border-violet-300"
                              />
                            </td>
                            <td className="px-3 py-1.5"><span className="inline-block w-2 h-2 rounded-full bg-violet-400" /></td>
                            <td className="px-3 py-1.5" colSpan={2}>
                              <div className="flex items-center gap-2 pl-6">
                                <span className="text-violet-700 text-[10px]">└─</span>
                                <button onClick={() => { setSelectedScadenza(p); setSheetOpen(true); }} className="text-slate-700 hover:text-violet-700">
                                  {p.compagnia || 'Altra polizza'}
                                </button>
                                {p.targa && <span className="font-mono text-[10px] bg-violet-100 px-1.5 rounded">{p.targa}</span>}
                                <span className="text-[10px] text-slate-500">📅 {p.data_scadenza}</span>
                              </div>
                            </td>
                            <td className="px-3 py-1.5 text-[10px] text-slate-500 hidden lg:table-cell">{p.tipo_scadenza || '-'}</td>
                            <td className="px-3 py-1.5 text-[10px] text-slate-500 hidden lg:table-cell">{p.premio ? `€ ${p.premio}` : '-'}</td>
                            <td className="px-3 py-1.5">
                              {p.wa_reminder_sent && !p.wa_reminder_failed && <Badge className="bg-green-100 text-green-700 text-[9px] border-0">✓ WA</Badge>}
                              {p.wa_reminder_failed && <Badge className="bg-red-100 text-red-700 text-[9px] border-0">✗ WA</Badge>}
                            </td>
                            <td className="px-3 py-1.5 text-right">
                              <button
                                onClick={() => openWhatsApp(p)}
                                disabled={sendingWaId === p.id}
                                className="p-1 rounded-md bg-green-100 hover:bg-green-200 text-green-700 disabled:opacity-50 inline-flex items-center gap-1 text-[10px]"
                                title="Invia WhatsApp per questa polizza"
                                data-testid={`expand-wa-${p.id}`}
                              >
                                {sendingWaId === p.id ? <Loader2 size={11} className="animate-spin" /> : <MessageCircle size={11} />}
                                Invia
                              </button>
                            </td>
                          </tr>
                        ))}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </div>
      )}

      {/* Payments Tab Content */}
      {tab === 'pagamenti' && (
        <div className="bg-white rounded-xl border overflow-hidden shadow-sm">
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="bg-slate-50 border-b">
                  <th className="text-left px-4 py-3 text-xs font-semibold text-slate-600 uppercase">Cliente</th>
                  <th className="text-left px-3 py-3 text-xs font-semibold text-slate-600 uppercase">Descrizione</th>
                  <th className="text-left px-3 py-3 text-xs font-semibold text-slate-600 uppercase">Importo</th>
                  <th className="text-left px-3 py-3 text-xs font-semibold text-slate-600 uppercase">Stato</th>
                  <th className="text-left px-3 py-3 text-xs font-semibold text-slate-600 uppercase">Data</th>
                  <th className="text-left px-3 py-3 text-xs font-semibold text-slate-600 uppercase">Creato da</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {payments.length === 0 ? (
                  <tr><td colSpan="6" className="text-center py-12 text-slate-400">Nessun pagamento registrato</td></tr>
                ) : payments.map(p => (
                  <tr key={p.id} className="hover:bg-slate-50/50" data-testid={`payment-row-${p.id}`}>
                    <td className="px-4 py-3 font-medium text-slate-800">{p.cliente_nome}</td>
                    <td className="px-3 py-3 text-xs text-slate-600">{p.descrizione}</td>
                    <td className="px-3 py-3 font-bold text-slate-800">{(p.importo || 0).toFixed(2)} EUR</td>
                    <td className="px-3 py-3">
                      <Badge className={p.stato === 'pagato' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}>
                        {p.stato === 'pagato' ? 'Pagato' : 'In attesa'}
                      </Badge>
                    </td>
                    <td className="px-3 py-3 text-xs text-slate-500">{new Date(p.created_at).toLocaleDateString('it-IT')}</td>
                    <td className="px-3 py-3 text-xs text-slate-500">{p.user_nome}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {/* Detail Sheet */}
      <Sheet open={sheetOpen} onOpenChange={setSheetOpen}>
        <SheetContent className="w-full sm:max-w-lg overflow-y-auto">
          {selectedScadenza && (
            <>
              <SheetHeader><SheetTitle>{selectedScadenza.nominativo}</SheetTitle></SheetHeader>
              <div className="mt-4 space-y-4">
                <div className="bg-slate-50 rounded-lg p-4 space-y-2 text-sm">
                  {selectedScadenza.compagnia && <div className="flex justify-between"><span className="text-slate-500">Compagnia</span><span className="font-medium">{selectedScadenza.compagnia}</span></div>}
                  {selectedScadenza.targa && <div className="flex justify-between"><span className="text-slate-500">Targa</span><span className="font-mono bg-white px-2 py-0.5 rounded border">{selectedScadenza.targa}</span></div>}
                  {selectedScadenza.tipo_veicolo && <div className="flex justify-between"><span className="text-slate-500">Veicolo</span><span>{selectedScadenza.tipo_veicolo}</span></div>}
                  {selectedScadenza.garanzie && <div className="flex justify-between"><span className="text-slate-500">Garanzie</span><span>{selectedScadenza.garanzie}</span></div>}
                  {(selectedScadenza.frequenza_pagamento || selectedScadenza.tipo_scadenza) && <div className="flex justify-between"><span className="text-slate-500">Tipo</span>{tipoScBadge(selectedScadenza.tipo_scadenza, selectedScadenza.frequenza_pagamento)}</div>}
                  {selectedScadenza.premio && <div className="flex justify-between"><span className="text-slate-500">Premio</span><span className="font-semibold">{fmtPremi(selectedScadenza.premio)}</span></div>}
                  {selectedScadenza.data_scadenza && <div className="flex justify-between"><span className="text-slate-500">Data Scadenza</span><span className="font-semibold">{selectedScadenza.data_scadenza}</span></div>}
                  {selectedScadenza.notes && <div><span className="text-slate-500 block mb-1">Note Import</span><span className="text-xs">{selectedScadenza.note}</span></div>}
                  <div className="flex justify-between items-center"><span className="text-slate-500">Esito</span>
                    <div className="flex items-center gap-2">
                      <Badge className={ESITI[selectedScadenza.esito]?.color}>{ESITI[selectedScadenza.esito]?.label}</Badge>
                      {selectedScadenza.esito_by && <span className="text-[10px] text-slate-400">da {selectedScadenza.esito_by}</span>}
                    </div>
                  </div>
                </div>

                {/* Cronologia WhatsApp del cliente */}
                {selectedScadenza.cellulare && (
                  <WhatsAppConversation phone={selectedScadenza.cellulare} onNewMessages={(n) => {
                    setScadenze(prev => prev.map(x => x.id === selectedScadenza.id ? { ...x, wa_unread_count: n } : x));
                  }} />
                )}

                {/* RCA Insurance Info */}
                {selectedScadenza.rca_verificato_at && (
                  <div className={`rounded-lg p-4 space-y-2 text-sm border ${selectedScadenza.rca_assicurato ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`} data-testid="rca-info-panel">
                    <div className="flex items-center gap-2 mb-2">
                      {selectedScadenza.rca_assicurato ? <ShieldCheck size={18} className="text-emerald-600" /> : <ShieldX size={18} className="text-red-600" />}
                      <span className={`font-bold text-sm ${selectedScadenza.rca_assicurato ? 'text-emerald-700' : 'text-red-700'}`}>
                        {selectedScadenza.rca_assicurato ? 'Veicolo Assicurato' : 'Veicolo NON Assicurato'}
                      </span>
                      {selectedScadenza.rca_sospesa && <Badge className="bg-amber-100 text-amber-700 border-0">Sospesa</Badge>}
                      {selectedScadenza.rca_furto && <Badge className="bg-red-100 text-red-700 border-0">Furto Segnalato</Badge>}
                    </div>
                    {selectedScadenza.rca_compagnia && <div className="flex justify-between"><span className="text-slate-500">Compagnia RCA</span><span className="font-semibold">{selectedScadenza.rca_compagnia}</span></div>}
                    {selectedScadenza.rca_scadenza && <div className="flex justify-between"><span className="text-slate-500">Scadenza Contratto</span><span className="font-semibold">{selectedScadenza.rca_scadenza}</span></div>}
                    {selectedScadenza.rca_scadenza_rata && selectedScadenza.rca_scadenza_rata !== selectedScadenza.rca_scadenza && (
                      <div className="flex justify-between"><span className="text-slate-500">Scadenza Rata</span><span className="font-medium text-amber-700">{selectedScadenza.rca_scadenza_rata}</span></div>
                    )}
                    {selectedScadenza.rca_frequenza && <div className="flex justify-between"><span className="text-slate-500">Frequenza</span><Badge variant="outline" className="text-xs">{selectedScadenza.rca_frequenza}</Badge></div>}
                  </div>
                )}

                {/* Promemoria WhatsApp: chi/quando (operatore o automatico) */}
                {(selectedScadenza.wa_reminder_sent || selectedScadenza.wa_reminder15_sent) && (
                  <div className="rounded-lg p-4 space-y-2 text-sm border bg-green-50 border-green-200" data-testid="wa-reminder-info-panel">
                    <div className="flex items-center gap-2 mb-1">
                      <MessageCircle size={16} className="text-green-600" />
                      <span className="font-bold text-sm text-green-700">Promemoria WhatsApp inviato</span>
                    </div>
                    {selectedScadenza.wa_reminder_sent && (
                      <div className="flex justify-between gap-3" data-testid="wa-reminder-24h-info">
                        <span className="text-slate-500 whitespace-nowrap">Scadenza (24h)</span>
                        <span className="font-medium text-right text-slate-700">
                          {waSenderLabel(selectedScadenza.wa_reminder_sent_by, selectedScadenza.wa_reminder_mode) || '—'}
                          {selectedScadenza.wa_reminder_sent_at ? <span className="block text-xs text-slate-500">il {fmtWaSent(selectedScadenza.wa_reminder_sent_at)}</span> : null}
                        </span>
                      </div>
                    )}
                    {selectedScadenza.wa_reminder15_sent && (
                      <div className="flex justify-between gap-3" data-testid="wa-reminder-15gg-info">
                        <span className="text-slate-500 whitespace-nowrap">Anticipo (15gg)</span>
                        <span className="font-medium text-right text-slate-700">
                          {waSenderLabel(selectedScadenza.wa_reminder15_sent_by, selectedScadenza.wa_reminder15_mode) || '—'}
                          {selectedScadenza.wa_reminder15_sent_at ? <span className="block text-xs text-slate-500">il {fmtWaSent(selectedScadenza.wa_reminder15_sent_at)}</span> : null}
                        </span>
                      </div>
                    )}
                  </div>
                )}

                <div>
                  <Label className="text-xs text-slate-500 mb-2 block">Cambia Esito</Label>
                  <div className="flex gap-1.5 flex-wrap">
                    {Object.entries(ESITI).map(([key, val]) => (
                      <button key={key} onClick={() => handleEsito(selectedScadenza.id, key)}
                        className={`px-3 py-1.5 rounded-full text-xs font-medium border transition-all ${selectedScadenza.esito === key ? val.color + ' ring-2 ring-offset-1' : 'bg-white border-slate-200 text-slate-500'}`}>
                        <span className={`inline-block w-2 h-2 rounded-full mr-1 ${val.dot}`} />{val.label}
                      </button>
                    ))}
                  </div>
                </div>
                {/* Payment Section */}
                {selectedScadenza.premio && !['rinnovato'].includes(selectedScadenza.esito) && (
                  <div className="border border-blue-200 rounded-lg p-4 bg-blue-50/30" data-testid="payment-section">
                    <h3 className="font-semibold text-sm text-slate-700 flex items-center gap-2 mb-3">
                      <CreditCard size={16} className="text-blue-600" /> Pagamento Polizza
                    </h3>
                    {selectedScadenza.payment_url ? (
                      <div className="space-y-2">
                        <div className="flex items-center justify-between text-xs">
                          <span className="text-slate-500">Importo</span>
                          <span className="font-bold text-slate-800">{(selectedScadenza.payment_importo || 0).toFixed(2)} EUR</span>
                        </div>
                        <div className="flex items-center justify-between text-xs">
                          <span className="text-slate-500">Stato</span>
                          <Badge className={selectedScadenza.payment_stato === 'pagato' ? 'bg-green-100 text-green-700' : 'bg-amber-100 text-amber-700'}>
                            {selectedScadenza.payment_stato === 'pagato' ? 'Pagato' : 'In attesa'}
                          </Badge>
                        </div>
                        <div className="flex gap-2 pt-2">
                          <a href={selectedScadenza.payment_url} target="_blank" rel="noreferrer" className="flex-1">
                            <Button size="sm" variant="outline" className="w-full text-xs"><ExternalLink size={13} className="mr-1" /> Apri Link</Button>
                          </a>
                          {selectedScadenza.cellulare && (
                            <Button size="sm" className="bg-green-600 hover:bg-green-700 text-white text-xs" onClick={() => handleSendPaymentLink(selectedScadenza, 'whatsapp')}>
                              <MessageCircle size={13} className="mr-1" /> WA
                            </Button>
                          )}
                          {selectedScadenza.email && (
                            <Button size="sm" className="bg-orange-500 hover:bg-orange-600 text-white text-xs" onClick={() => handleSendPaymentLink(selectedScadenza, 'email')}>
                              <Mail size={13} className="mr-1" /> Email
                            </Button>
                          )}
                        </div>
                      </div>
                    ) : (
                      <Button size="sm" onClick={() => handleCreatePaymentLink(selectedScadenza)} disabled={paymentLoading === selectedScadenza.id}
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white text-xs" data-testid="create-payment-link-btn">
                        {paymentLoading === selectedScadenza.id ? <Loader2 size={13} className="animate-spin mr-1" /> : <CreditCard size={13} className="mr-1" />}
                        Crea Link Pagamento ({fmtPremi(selectedScadenza.premio)})
                      </Button>
                    )}
                  </div>
                )}

                <div className="flex gap-2 flex-wrap">
                  {selectedScadenza.cellulare && <Button size="sm" className="bg-green-600 hover:bg-green-700" onClick={() => openWhatsApp(selectedScadenza)}><MessageCircle size={14} className="mr-1.5" /> WhatsApp</Button>}
                  {selectedScadenza.cellulare && <CallButton number={selectedScadenza.cellulare} description={selectedScadenza.nominativo || ''} variant="button" className="inline-flex items-center gap-1.5 rounded-md text-sm font-medium h-8 px-3 bg-blue-600 text-white hover:bg-blue-700"><PhoneCall size={14} /> Chiama</CallButton>}
                  <Button size="sm" variant="outline" className="text-purple-700 border-purple-200" onClick={() => openPreventivo(selectedScadenza)}><FileText size={14} className="mr-1.5" /> Preventivo</Button>
                  <Button size="sm" variant="outline" className="text-amber-700 border-amber-200" onClick={() => { setTaskTarget(selectedScadenza); setTaskOpen(true); }}><ClipboardList size={14} className="mr-1.5" /> Task</Button>
                  {selectedScadenza.targa && <Button size="sm" variant="outline" className="text-indigo-700 border-indigo-200" onClick={() => handleCheckRca(selectedScadenza.targa, selectedScadenza.id)} disabled={rcaLoading === selectedScadenza.id} data-testid="detail-rca-btn">{rcaLoading === selectedScadenza.id ? <Loader2 size={14} className="animate-spin mr-1.5" /> : <ShieldCheck size={14} className="mr-1.5" />} Verifica RCA</Button>}
                  <Button size="sm" variant="outline" className="text-indigo-700 border-indigo-200" onClick={() => { const parts = (selectedScadenza.data_scadenza || '').split('/'); const g = parseInt(parts[0]) || 1; setSpostaTarget(selectedScadenza); setSpostaDest({ giorno: g, mese: mese === 12 ? 1 : mese + 1, anno: mese === 12 ? anno + 1 : anno }); setSpostaOpen(true); }}><ArrowRightLeft size={14} className="mr-1.5" /> Sposta</Button>
                </div>
                <div>
                  <h3 className="font-semibold text-sm text-slate-700 mb-3">Note</h3>
                  <div className="space-y-2 mb-3 max-h-[250px] overflow-y-auto">
                    {(selectedScadenza.note_list || []).length === 0 && <p className="text-xs text-slate-400">Nessuna nota</p>}
                    {(selectedScadenza.note_list || []).map(n => (
                      <div key={n.id} className="bg-yellow-50 border border-yellow-200 rounded-lg p-3">
                        {editingNote === n.id ? (
                          <div className="space-y-2">
                            <Textarea value={editNoteText} onChange={e => setEditNoteText(e.target.value)} className="min-h-[50px] text-sm" />
                            <div className="flex gap-1.5">
                              <Button size="sm" className="h-7 text-xs" onClick={() => handleEditNote(n.id)}>Salva</Button>
                              <Button size="sm" variant="outline" className="h-7 text-xs" onClick={() => { setEditingNote(null); setEditNoteText(''); }}>Annulla</Button>
                            </div>
                          </div>
                        ) : (
                          <>
                            <div className="flex items-start justify-between gap-2">
                              <p className="text-sm flex-1">{n.testo}</p>
                              <div className="flex gap-0.5">
                                <button onClick={() => { setEditingNote(n.id); setEditNoteText(n.testo); }} className="p-1 text-yellow-600 hover:text-yellow-800"><StickyNote size={12} /></button>
                                <button onClick={() => handleDeleteNote(n.id)} className="p-1 text-yellow-600 hover:text-red-500"><Trash2 size={12} /></button>
                              </div>
                            </div>
                            <p className="text-xs text-slate-400 mt-1">{n.autore} - {new Date(n.data).toLocaleString('it-IT')}</p>
                          </>
                        )}
                      </div>
                    ))}
                  </div>
                  <div className="flex gap-2">
                    <Textarea value={noteText} onChange={e => setNoteText(e.target.value)} placeholder="Scrivi una nota..." className="min-h-[60px] text-sm" data-testid="note-input" />
                    <Button size="sm" className="self-end" onClick={handleAddNote} disabled={!noteText.trim()} data-testid="add-note-btn"><Send size={14} /></Button>
                  </div>
                </div>
              </div>
            </>
          )}
        </SheetContent>
      </Sheet>

      {/* Consulta Sintesi Dialog */}
      <Dialog open={!!sintesiTarget} onOpenChange={(v) => { if (!v) { setSintesiTarget(null); setSintesiData(null); } }}>
        <DialogContent className="max-w-lg" data-testid="sintesi-dialog">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-base">
              <Landmark size={17} className="text-indigo-600" />
              Gestionale Sintesi — targa {sintesiTarget?.targa?.toUpperCase()}
            </DialogTitle>
          </DialogHeader>
          {sintesiLoading ? (
            <div className="py-8 text-center space-y-2">
              <Loader2 size={24} className="animate-spin mx-auto text-indigo-500" />
              <p className="text-xs text-slate-500">Consultazione in corso sul gestionale... (può richiedere fino a un minuto)</p>
            </div>
          ) : sintesiData?.polizze?.length ? (
            <div className="space-y-2">
              <p className="text-[11px] text-slate-400">{sintesiData.polizze.length} polizze trovate {sintesiData.fonte === 'cache' ? '(dati recenti in cache)' : '(lettura in tempo reale)'}</p>
              {sintesiData.polizze.map((p, i) => (
                <div key={i} className="border rounded-lg p-3 bg-slate-50/60 text-sm space-y-0.5" data-testid={`sintesi-polizza-${i}`}>
                  <div className="flex items-center justify-between">
                    <span className="font-semibold text-slate-700">{p.contraente || 'Contraente n.d.'}</span>
                    {p.compagnia && <Badge className="bg-indigo-100 text-indigo-700 border-0 text-[10px]">{p.compagnia}</Badge>}
                  </div>
                  <p className="text-xs text-slate-500">Polizza n. {p.numero || 'n.d.'}</p>
                  <div className="flex gap-4 text-xs mt-1">
                    <span className="text-slate-600">Scad. copertura: <b>{p.scadenza_copertura || 'n.d.'}</b></span>
                    <span className="text-slate-600">Scad. contratto: <b>{p.data_scadenza || 'n.d.'}</b></span>
                  </div>
                </div>
              ))}
            </div>
          ) : (
            <p className="py-6 text-center text-sm text-slate-400 italic">Nessuna polizza trovata su Sintesi per questa targa.</p>
          )}
        </DialogContent>
      </Dialog>

      {/* Create Task Dialog */}
      <Dialog open={taskOpen} onOpenChange={(open) => { setTaskOpen(open); if (!open) setTaskTarget(null); }}>
        <DialogContent>
          <DialogHeader><DialogTitle>Crea Task da Scadenza</DialogTitle></DialogHeader>
          {taskTarget && (
            <form onSubmit={handleCreateTask} className="space-y-4 pt-2">
              <div><Label>Titolo</Label><Input name="titolo" defaultValue={`Scadenza: ${taskTarget.nominativo} - ${taskTarget.compagnia || ''}`} required /></div>
              <div><Label>Descrizione</Label><Textarea name="descrizione" defaultValue={`Polizza in scadenza per ${taskTarget.nominativo}\nTarga: ${taskTarget.targa || 'N/A'}\nCompagnia: ${taskTarget.compagnia || 'N/A'}\nCellulare: ${taskTarget.cellulare || 'N/A'}\nData: ${taskTarget.data_scadenza || MESI[mese] + ' ' + anno}\nPremio: ${fmtPremi(taskTarget.premio)}`} className="min-h-[100px] text-sm" /></div>
              <div><Label>Assegna a</Label><select name="assignee" className="w-full h-10 px-3 rounded-md border border-slate-200 text-sm"><option value="">Non assegnato</option>{users.map(u => <option key={u.id} value={u.id}>{u.nome} {u.cognome}</option>)}</select></div>
              <Button type="submit" className="w-full"><ClipboardList size={16} className="mr-2" /> Crea Task</Button>
            </form>
          )}
        </DialogContent>
      </Dialog>

      {/* Sposta Scadenza Dialog */}
      <Dialog open={spostaOpen} onOpenChange={(open) => { setSpostaOpen(open); if (!open) setSpostaTarget(null); }}>
        <DialogContent>
          <DialogHeader><DialogTitle>Sposta Scadenza</DialogTitle></DialogHeader>
          {spostaTarget && (
            <div className="space-y-4 pt-2">
              <p className="text-sm text-slate-600">
                Sposta la scadenza di <strong>{spostaTarget.nominativo}</strong> ({spostaTarget.targa || 'N/A'}) ad un&apos;altra data.
              </p>
              <div className="grid grid-cols-3 gap-3">
                <div>
                  <Label>Giorno</Label>
                  <Select value={String(spostaDest.giorno)} onValueChange={(v) => setSpostaDest(prev => ({ ...prev, giorno: parseInt(v) }))}>
                    <SelectTrigger data-testid="sposta-giorno-select"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {Array.from({ length: 31 }, (_, i) => i + 1).map(g => <SelectItem key={g} value={String(g)}>{g}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Mese</Label>
                  <Select value={String(spostaDest.mese)} onValueChange={(v) => setSpostaDest(prev => ({ ...prev, mese: parseInt(v) }))}>
                    <SelectTrigger data-testid="sposta-mese-select"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {MESI.slice(1).map((m, i) => <SelectItem key={i + 1} value={String(i + 1)}>{m}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
                <div>
                  <Label>Anno</Label>
                  <Select value={String(spostaDest.anno)} onValueChange={(v) => setSpostaDest(prev => ({ ...prev, anno: parseInt(v) }))}>
                    <SelectTrigger data-testid="sposta-anno-select"><SelectValue /></SelectTrigger>
                    <SelectContent>
                      {[anno - 1, anno, anno + 1, anno + 2].map(a => <SelectItem key={a} value={String(a)}>{a}</SelectItem>)}
                    </SelectContent>
                  </Select>
                </div>
              </div>
              <Button className="w-full" onClick={handleSposta} data-testid="sposta-confirm-btn">
                <ArrowRightLeft size={16} className="mr-2" /> Sposta al {spostaDest.giorno}/{spostaDest.mese}/{spostaDest.anno}
              </Button>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Payment Link Created Dialog */}
      <Dialog open={paymentOpen} onOpenChange={setPaymentOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle className="flex items-center gap-2"><CreditCard size={18} className="text-blue-600" /> Link Pagamento Creato</DialogTitle></DialogHeader>
          {paymentTarget && paymentUrl && (
            <div className="space-y-4 pt-2">
              <div className="bg-blue-50 rounded-lg p-4 text-center">
                <p className="text-sm text-slate-600 mb-1">Importo da pagare</p>
                <p className="text-2xl font-bold text-slate-900">{(paymentTarget.payment_importo || 0).toFixed(2)} EUR</p>
                <p className="text-xs text-slate-500 mt-1">{paymentTarget.nominativo} - {paymentTarget.compagnia}</p>
              </div>
              <div className="space-y-2">
                <a href={paymentUrl} target="_blank" rel="noreferrer">
                  <Button className="w-full" variant="outline"><ExternalLink size={14} className="mr-2" /> Apri Link Pagamento</Button>
                </a>
                {paymentTarget.cellulare && (
                  <Button className="w-full bg-green-600 hover:bg-green-700 text-white" onClick={() => { handleSendPaymentLink(paymentTarget, 'whatsapp'); setPaymentOpen(false); }}>
                    <MessageCircle size={14} className="mr-2" /> Invia via WhatsApp
                  </Button>
                )}
                {paymentTarget.email && (
                  <Button className="w-full bg-orange-500 hover:bg-orange-600 text-white" onClick={() => { handleSendPaymentLink(paymentTarget, 'email'); setPaymentOpen(false); }}>
                    <Mail size={14} className="mr-2" /> Invia via Email
                  </Button>
                )}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* RCA Check Dialog */}
      <Dialog open={rcaOpen} onOpenChange={(v) => { setRcaOpen(v); if (!v) setRcaResult(null); }}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle>Verifica Assicurazione RCA</DialogTitle></DialogHeader>
          <div className="space-y-4 pt-2">
            <div>
              <Label>Targa del veicolo</Label>
              <div className="flex gap-2 mt-1">
                <Input
                  value={rcaTarga}
                  onChange={e => setRcaTarga(e.target.value.toUpperCase())}
                  placeholder="Es. AB123CD"
                  className="font-mono text-lg tracking-wider"
                  onKeyDown={e => { if (e.key === 'Enter') handleManualRcaCheck(); }}
                  data-testid="rca-targa-input"
                />
                <Button onClick={handleManualRcaCheck} disabled={rcaLoading === 'manual' || !rcaTarga.trim()} data-testid="rca-check-submit">
                  {rcaLoading === 'manual' ? <Loader2 size={16} className="animate-spin" /> : <ShieldCheck size={16} />}
                </Button>
              </div>
            </div>

            {rcaResult && (
              <div className={`rounded-lg p-4 space-y-2.5 border ${rcaResult.assicurato ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'}`} data-testid="rca-result-panel">
                <div className="flex items-center gap-2">
                  {rcaResult.assicurato
                    ? <ShieldCheck size={22} className="text-emerald-600" />
                    : <ShieldX size={22} className="text-red-600" />}
                  <span className={`font-bold ${rcaResult.assicurato ? 'text-emerald-700' : 'text-red-700'}`}>
                    {rcaResult.assicurato ? 'Veicolo Assicurato' : 'Veicolo NON Assicurato'}
                  </span>
                </div>
                {rcaResult.assicurazione_sospesa && (
                  <div className="flex items-center gap-1.5 text-amber-700 bg-amber-100 rounded px-2 py-1">
                    <ShieldAlert size={14} /> <span className="text-xs font-medium">Assicurazione Sospesa</span>
                  </div>
                )}
                {rcaResult.furto_segnalato && (
                  <div className="flex items-center gap-1.5 text-red-700 bg-red-100 rounded px-2 py-1">
                    <AlertTriangle size={14} /> <span className="text-xs font-medium">Furto Segnalato!</span>
                  </div>
                )}
                <div className="space-y-1.5 text-sm">
                  <div className="flex justify-between"><span className="text-slate-500">Targa</span><span className="font-mono font-bold">{rcaResult.targa}</span></div>
                  {rcaResult.tipo_veicolo_rca && <div className="flex justify-between"><span className="text-slate-500">Tipo Veicolo</span><span>{rcaResult.tipo_veicolo_rca}</span></div>}
                  {rcaResult.compagnia_rca && <div className="flex justify-between"><span className="text-slate-500">Compagnia</span><span className="font-semibold">{rcaResult.compagnia_rca}</span></div>}
                  {rcaResult.numero_polizza && <div className="flex justify-between"><span className="text-slate-500">N. Polizza</span><span className="font-mono">{rcaResult.numero_polizza}</span></div>}
                  {rcaResult.scadenza_annuale && <div className="flex justify-between"><span className="text-slate-500">Scadenza Contratto</span><span className="font-semibold">{rcaResult.scadenza_annuale}</span></div>}
                  {rcaResult.scadenza_rata && rcaResult.scadenza_rata !== rcaResult.scadenza_annuale && (
                    <div className="flex justify-between"><span className="text-slate-500">Scadenza Rata</span><span className="font-medium text-amber-700">{rcaResult.scadenza_rata}</span></div>
                  )}
                  {rcaResult.frequenza && <div className="flex justify-between"><span className="text-slate-500">Frequenza</span><span className="font-medium">{rcaResult.frequenza}</span></div>}
                </div>
              </div>
            )}
          </div>
        </DialogContent>
      </Dialog>
    </div>
    </TooltipProvider>
  );
};

export default Scadenze;
